import './ImagesBlock.scss'

import React from 'react'
import {ImageType} from '../../types'
import {Mod, style} from '../../util/style'
import {Picture} from '../ui/Picture'
import {Block} from './Blocks'

const styles = style('imagesblock', ['caption'])

export type ImagesBlockType = {
	images?: Array<ImageType>
}

export const ImagesBlock: React.FC<
	ImagesBlockType & {container?: boolean; sidebar?: boolean}
> = ({container, sidebar, images}) => {
	if (!images || images.length === 0) return null

	return (
		<Block
			className={styles().mod({multiple: images.length > 1})}
			container={container}
			sidebar={sidebar}
		>
			<div className={styles('images')}>
				{images.map(
					(image, i) =>
						image && (
							<figure
								key={i}
								className={styles('images-item').mod({
									portrait: image.height > image.width
								})}
							>
								<Picture {...image} />
								<ImagesBlockCaption
									caption={image?.meta?.caption}
									right={i % 2 !== 0}
								/>
							</figure>
						)
				)}
			</div>
		</Block>
	)
}

export const ImagesBlockCaption: React.FC<{
	caption: string
	right?: boolean
}> = ({caption, right}) => {
	if (!caption) return null
	return (
		<figcaption className={styles.caption().mod({right})}>{caption}</figcaption>
	)
}
